import React, { Component } from 'react'
import { FormattedMessage, intlShape, InjectedIntlProps, injectIntl } from 'react-intl'
import classNames from 'classnames'

require('./styles.scss')

interface IMessage {
  id: string
  values: { [key: string]: string | number | boolean | Date | JSX.Element }
}

interface IContentLoadingBoxProps extends InjectedIntlProps {
  spinner: boolean
  message?: IMessage
  className?: string
  children?: Object
}

/**
 * Loading dots taken from the WM loading animation
 */
class ContentLoadingBox extends Component<IContentLoadingBoxProps> {

  static contextTypes = {
    intl: intlShape
  }

  // Change the loader here
  renderDots() {
    return (<div className="spinner">
      <div className='bounce bounce1'></div>
      <div className='bounce bounce2'></div>
      <div className='bounce bounce3'></div>
    </div>)
  }

  render() {

    const {
      message,
      spinner,
      className,
      children
    } = this.props

    const hasIntl = !!(message && message.values)

    return (<div
      className={classNames(className, 'contentLoadingBox content-loading-box')}
    >
      {spinner
        ? <div className='contentLoadingBoxSpinner'>
          {this.renderDots()}
        </div>
        : false}
      {hasIntl
        ? <FormattedMessage
          id={message.id || 'content.loading'}
          values={message.values}
        />
        : null}
      {children}
    </div>)
  }
}

export default injectIntl(ContentLoadingBox)
